export default __webpack_public_path__ + "static/media/streamline_green.176a7a09.svg";